import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, Row } from 'react-bootstrap';
import useCurrentPage from '../../../hooks/useCurrentPage';
import { pure } from '../../../../src/web/utils/react';
import style from './ClassicUnitCategory.scss';
import ApplicableFees from '../../stateful/ApplicableFees';


const propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  siteUnitCategoryId: PropTypes.string.isRequired,
};

const defaultProps = {};

const ClassicUnitCategory = ({ name, price, facility, siteUnitCategoryId }) => {
  const { primaryColorBackgroundClass, secondaryColorBackgroundHoverClass,
    buttonStyleClass } = useCurrentPage();

  const feeFilter = {
    facilityId: facility?.id,
    unitSummaryId: siteUnitCategoryId,
  };

  return (
    <div className={style.padBot}>
      <div className={style.categoryText}>{name}</div>
      <div className={style.boxFrame}>
        <div className={style.littleText}>{price === 'Call' ? 'please' : 'starting at'}</div>
        <Row className={style.center}>
          <div className={style.costText}>{price === 'Call' ? price : `$ ${price}`}</div>
          <div
            className={`${style.monthText} ${price.toString().length > 3 ? '' : style.inline}`}
          >
            {price === 'Call' ? '' : ' / mo'}
          </div>
          <ApplicableFees
            facility={facility}
            feeFilter={feeFilter}
            feesLinkClass={style.applicableFeesLink}
            applicableFeesDownArrowClass={style.applicableFeesDownArrow}
            displayApplicableFees={typeof price === 'number'}
          />
        </Row>
      </div>
      <Button
        block
        variant="primary"
        className={cx(
          buttonStyleClass,
          primaryColorBackgroundClass,
          secondaryColorBackgroundHoverClass,
          style.button,
        )}
      >
        See Units
      </Button>
    </div>
  );
};

ClassicUnitCategory.propTypes = propTypes;
ClassicUnitCategory.defaultProps = defaultProps;

export default pure()(ClassicUnitCategory);
